import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppLink from "components/common/AppLink";
import If from "components/common/If";
import Page from "components/common/page/Page";
import SeasonView from "components/entities/app/season/SeasonView";
import { AppRoutes } from "config/router";
import { useParams } from "react-router-dom";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

const SeasonViewPage = () => {
    const params = useParams<{ id: string }>();
    const context = useAppContext();

    const actions = () => {
        return (
            <If condition={context.userHasRole(Roles.ADMIN)}>
                <AppLink className="btn link" to={AppRoutes.SEASON_EDIT} params={{ id: params.id }} >
                    <FontAwesomeIcon icon={faPencil} />
                </AppLink>
            </If>
        )
    }

    return (
        <Page title="pages.season.view" actions={actions}>
            <SeasonView model={params.id} />
        </Page>
    )
}
export default SeasonViewPage;
